/*
 * @Description:
 * @Date: 2022-09-19 10:13:07
 */
import { route, PageConfig } from './src/router/index';

const name = 'zsManage';

export { name, route, PageConfig };
